<script setup lang="ts">
import logger from '@/modules/common/services/logger.service';
import { useRouter } from '@/router/router';
import { useAuthStore } from '@/store/auth-store';
import { onBeforeMount } from 'vue';

const router = useRouter();
const authStore = useAuthStore();

onBeforeMount(async () => {
  try {
    // now that we have a proper page state rendered, try to logout and redirect
    await authStore.logout();
    await router.replace({ name: 'login' });
  } catch (err) {
    // critical error, must redirect to error page, to avoid possible redirection loops
    logger.error('failed to logout', err);
    await router.replace({ name: 'error-500' });
  }
});
</script>

<template>
  <VContainer class="flex-column justify-center fill-height">
    <VProgressCircular color="primary" indeterminate :size="200" />
    <h3 class="mt-4">Logging out...</h3>
  </VContainer>
</template>
